import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAttributeValue } from "src/models/Company/AttributeValue.models";

interface AttributeValueState {
  attributeValues: IAttributeValue[];
  attributeValueToEdit: IAttributeValue | null;
}

const initialState: AttributeValueState = {
  attributeValues: [],
  attributeValueToEdit: null,
};

const AttributeValueSlice = createSlice({
  name: "AttributeValue",
  initialState,
  reducers: {
    setAttributeValueList: (state, action: PayloadAction<IAttributeValue[]>) => {
      state.attributeValues = action.payload;
    },
    concatListAttributeValue: (
      state: AttributeValueState,
      action: PayloadAction<IAttributeValue[]>
    ) => {
      state.attributeValues = [...state.attributeValues.concat(action.payload)];
    },
    setAttributeValueToEdit: (state, action: PayloadAction<IAttributeValue | null>) => {
      state.attributeValueToEdit = action.payload;
    },
    addAttributeValue: (state, action: PayloadAction<IAttributeValue>) => {
      state.attributeValues.push(action.payload);
    },
    updateAttributeValue: (state, action: PayloadAction<IAttributeValue>) => {
      let itemIndex = state.attributeValues.findIndex(
        item => item.attributeId === action.payload.attributeId
      );
      if (itemIndex !== -1) state.attributeValues[itemIndex] = action.payload;
    },
    deleteAttributeValue: (state, action: PayloadAction<number>) => {
      const newArray = state.attributeValues.filter(
        item => item.attributeValueId !== action.payload
        );
      state.attributeValues = newArray;
    },
  },
});

export const {
  setAttributeValueList,
  concatListAttributeValue,
  setAttributeValueToEdit,
  addAttributeValue,
  updateAttributeValue,
  deleteAttributeValue,
} = AttributeValueSlice.actions;

export default AttributeValueSlice.reducer;
